/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GLChartService = {
  async getByName(name) {
    const requestScreenData = {
      url: "api/GLChart",
      top: "1",
      filter: `Description eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code) {
    const requestScreenData = {
      url: "api/GLChart",
      top: "1",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    params.key = ["Code"];
    params.keyType = { Code: "Int32" };
    return ApiService.createDataSource(url, params);
  },
  dataSourceConfig2(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getGLChartData(filter) {
    const requestScreenData = {
      url: "api/GLChart",
      top: "1",
      filter: filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { GLChartService };
